import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
   0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const spinnerWidthLarge = '4px';
const spinnerWidthSmall = '3px';
const spinnerWidthExtraSmall = '2px';
export const SpinnerIcon = styled.div<{
  $size: 'extraSmall' | 'small' | 'large';
  $useAccentColor: boolean;
}>`
  border-width: ${({ $size }) => {
    switch ($size) {
      case 'extraSmall':
        return spinnerWidthExtraSmall;
      case 'small':
        return spinnerWidthSmall;
      case 'large':
      default:
        return spinnerWidthLarge;
    }
  }};
  border-style: solid;
  border-color: ${({ $useAccentColor }) =>
    $useAccentColor
      ? `var(--icon-primary) transparent var(--icon-primary)
    var(--icon-primary)`
      : `var(--icon-default) transparent var(--icon-default)
    var(--icon-default)`};
  width: ${({ $size }) => {
    switch ($size) {
      case 'extraSmall':
        return '12px';
      case 'small':
        return '16px';
      case 'large':
      default:
        return '40px';
    }
  }};
  height: ${({ $size }) => {
    switch ($size) {
      case 'extraSmall':
        return '12px';
      case 'small':
        return '16px';
      case 'large':
      default:
        return '40px';
    }
  }};
  border-radius: 50%;
  position: relative;
  animation: ${rotate} 1s linear infinite;

  &:before,
  &:after {
    content: '';
    width: ${({ $size }) => {
      switch ($size) {
        case 'extraSmall':
          return spinnerWidthExtraSmall;
        case 'small':
          return spinnerWidthSmall;
        case 'large':
        default:
          return spinnerWidthLarge;
      }
    }};
    height: ${({ $size }) => {
      switch ($size) {
        case 'extraSmall':
          return spinnerWidthExtraSmall;
        case 'small':
          return spinnerWidthSmall;
        case 'large':
        default:
          return spinnerWidthLarge;
      }
    }};
    border-radius: 50%;
    background: ${({ $useAccentColor }) =>
      $useAccentColor ? `var(--icon-primary)` : `var(--icon-default)`};
    position: absolute;
  }

  &:before {
    top: ${({ $size }) => {
      switch ($size) {
        case 'extraSmall':
          return '-1px';
        case 'small':
          return '-1px';
        case 'large':
        default:
          return '2px';
      }
    }};
    right: ${({ $size }) => {
      switch ($size) {
        case 'extraSmall':
          return '0px';
        case 'small':
          return '-1px';
        case 'large':
        default:
          return '1px';
      }
    }};
  }

  &:after {
    bottom: ${({ $size }) => {
      switch ($size) {
        case 'extraSmall':
          return '-1px';
        case 'small':
          return '-1px';
        case 'large':
        default:
          return '2px';
      }
    }};
    right: ${({ $size }) => {
      switch ($size) {
        case 'extraSmall':
          return '0px';
        case 'small':
          return '-1px';
        case 'large':
        default:
          return '1px';
      }
    }};
  }
`;
